import { Vendor } from "./types";

export const mockVendors: Vendor[] = [
  {
    id: "1",
    name: "Ridebase",
    skills: ["Report issues", "Drive"],
    businessModels: ["Ridebase Miami", "Ridebase Orlando"],
    rideAssignment: "Manual",
    assignedDrivers: 3,
    contactEmail: "contact@ridebase.com",
    status: "Active"
  },
  {
    id: "2",
    name: "Ridebase - Auto Accept",
    skills: [],
    businessModels: ["Ridebase Austin", "Ridebase Dallas", "Ridebase..."],
    rideAssignment: "Auto",
    assignedDrivers: 183,
    status: "Active"
  },
  {
    id: "3",
    name: "Ridebase - Company Driver",
    skills: [],
    businessModels: ["Ridebase Phoenix"],
    rideAssignment: "Auto",
    assignedDrivers: 0,
    status: "Active"
  },
  {
    id: "4",
    name: "Ridebase - Priority 3 - Manual A...",
    skills: [],
    businessModels: ["Ridebase Seattle", "Ridebase Portland", "..."],
    rideAssignment: "Manual",
    assignedDrivers: 166,
    status: "Active"
  },
  {
    id: "5",
    name: "Ridebase - Booster Seat",
    skills: [],
    businessModels: ["Ridebase Boston"],
    rideAssignment: "Manual",
    assignedDrivers: 31,
    status: "Active"
  },
  {
    id: "6",
    name: "Ridebase - Standard",
    skills: [],
    businessModels: ["Ridebase Denver", "Ridebase Las Vegas", "..."],
    rideAssignment: "Manual",
    assignedDrivers: 4765,
    status: "Active"
  },
  {
    id: "7",
    name: "Ridebase - Priority 7 - Auto Acc...",
    skills: [],
    businessModels: ["Ridebase San Diego"],
    rideAssignment: "Auto",
    assignedDrivers: 4,
    status: "Active"
  },
  {
    id: "8",
    name: "Bay Area Mobility",
    skills: [],
    businessModels: ["Ridebase San Francisco"],
    rideAssignment: "Auto",
    assignedDrivers: 0,
    status: "Active"
  },
  {
    id: "9",
    name: "Ridebase - Priority 5 - Manual A...",
    skills: [],
    businessModels: ["Ridebase Nashville", "Ridebase Atlanta"],
    rideAssignment: "Manual",
    assignedDrivers: 51,
    status: "Active"
  },
  {
    id: "10",
    name: "East Coast Transport",
    skills: [],
    businessModels: ["Ridebase New York"],
    rideAssignment: "Auto",
    assignedDrivers: 2,
    status: "Active"
  }
];